
<template>
  <div class="complainant_project_info">
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="250px" class="ruleForm"
    >
      <el-form-item label="标段名称：" prop="projectName" class="single-row">
<!--        <el-input v-model="ruleForm.projectName"></el-input>-->
        <span>{{ruleForm.complaintProjectVo&&ruleForm.complaintProjectVo.bidSectionName}}</span>
      </el-form-item>
      <el-form-item label="标段编号：" prop="projectCode" class="double-row">
        <span>{{ruleForm.complaintProjectVo&&ruleForm.complaintProjectVo.bidSectionCode}}</span>
      </el-form-item>
      <el-form-item label="招标项目编号：" prop="projectCode" class="double-row">
        <span>{{ruleForm.complaintProjectVo&&ruleForm.complaintProjectVo.tenderProjectCode}}</span>
      </el-form-item>
      <el-form-item label="招标项目名称：" prop="corporateRepresentative" class="single-row">
        <span>{{ruleForm.complaintProjectVo&&ruleForm.complaintProjectVo.tenderProjectName}}</span>
      </el-form-item>

      <el-form-item label=" 招标人：" prop="tenderer" class="double-row">
        <span>{{ruleForm.complaintProjectVo&&ruleForm.complaintProjectVo.tendererName}}</span>
      </el-form-item>
      <el-form-item label=" 招标代理机构：" prop="tenderAgent" class="double-row">
        <span>{{ruleForm.complaintProjectVo&&ruleForm.complaintProjectVo.tenderAgencyName}}</span>
      </el-form-item>
      <el-form-item label=" 中标人：" prop="tenderer" class="double-row">
        <span>{{ruleForm.complaintProjectVo&&ruleForm.complaintProjectVo.winnerName}}</span>
      </el-form-item>
      <el-form-item label=" 中标时间：" prop="bidWinTimes" class="double-row">
        <span>{{ruleForm.complaintProjectVo&&ruleForm.complaintProjectVo.winnerTime}}</span>
      </el-form-item>
      <el-form-item label="中标金额：" prop="bidAmount" class="double-row">
        <span>{{ruleForm.complaintProjectVo&&ruleForm.complaintProjectVo.winnerPrice}}</span>
      </el-form-item>
      <el-form-item label="投诉人参加本项目投标情况：" prop="bidProject" class="single-row">
        <span>{{ruleForm.complaintProjectVo&&ruleForm.complaintProjectVo.tenderProjectInfo}}</span>
      </el-form-item>
      <el-form-item label="投诉人与本项目利害关系情况：" prop="interestsProject" class="single-row">
        <span>{{ruleForm.complaintProjectVo&&ruleForm.complaintProjectVo.tenderRelationInfo}}</span>
      </el-form-item>
    </el-form>

  </div>

</template>
<script>
export default {
  props:['ruleForm'],
  data() {
    return {
      rules: {
        projectName: [{ required: true, message: '请输入标段名称', trigger: 'blur' }],
        projectCode: [{ required: true, message: '请输入标段编号', trigger: 'blur' }],
        bidAmount: [{ required: true, message: '请输入中标金额', trigger: 'blur' }],
        tenderer: [{ required: true, message: '请输入招标人', trigger: 'blur' }],
        tenderAgent: [{ required: true, message: '请输入投诉代理', trigger: 'blur' }],
        bidWin: [{ required: true, message: '请输入中标人', trigger: 'blur' }],
        bidWinTimes: [{ required: true, message: '请输入中标时间', trigger: 'blur' }],
        bidProject: [{ required: true, message: '请输入投诉人参加本项目投标情况', trigger: 'blur' }],
        interestsProject: [{ required: true, message: '请输入投诉人与本项目利害关系情况：', trigger: 'blur' }],
      }
    };
  },
  methods: {

  }
}
</script>
<style lang="scss" scoped>
.complainant_project_info {
  .ruleForm{
    display: flex;flex-wrap: wrap;justify-content: space-between;
    width: 100%;
  }
  .el-dialog__wrapper /deep/ .el-dialog__header {
  }

  .el-dialog__wrapper /deep/ .el-dialog__body {
    padding: 10px 20px;
  }

  .el-form /deep/ .el-form-item.single-row {
    width: 100%;
    margin-bottom: 20px;
  }

  .el-form /deep/ .el-form-item.double-row {
    width: 50%;
    margin-bottom: 20px;
  }

  .el-form /deep/ .el-form-item {
    .el-form-item__label, .el-form-item__content {
      line-height: 26px;
    }
  }

  .el-form /deep/ .el-form-item {
    width: 50%;
    margin-bottom: 0px;
  }

  .el-form /deep/ .el-form-item.searchInForm {
    width: auto;
    margin-bottom: 10px;

    .el-form-item__label {
      line-height: 32px;
    }
  }

  .el-dialog__wrapper /deep/ .el-dialog__footer {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .link:hover {
    cursor: pointer; //鼠标变手
    /*background-color: #1890FF; //链接变颜色*/
    /*color: white!important;*/
  }
}

</style>
